/** @jsxImportSource @emotion/react */
import { memo } from 'react';
import { TextField } from '@mui/material';
import { CustomFieldConditionValue } from '../typings';

interface Props {
  value: CustomFieldConditionValue;
  onChange: (next: CustomFieldConditionValue) => void;
  placeholder?: string;
}

const TextValueInput = ({ value, onChange, placeholder = 'Enter value' }: Props) => {
  const text = value.type === 'VALUE' && typeof value.value === 'string' ? value.value : '';
  return (
    <TextField
      fullWidth
      size="small"
      value={text}
      placeholder={placeholder}
      onChange={(e) => onChange({ type: 'VALUE', value: e.target.value })}
      InputProps={{ sx: { fontSize: 14 } }}
    />
  );
};

export default memo(TextValueInput);
